<template>
  <div class="Document" tabindex="0">
    <div class="action-bar">
      <button v-if="selectedItem && isMap" @click="onClick_addToMap" aria-label="Adicionar ao mapa interativo">
        <i class="material-icons icon">language</i>
        <div class="Tooltip-right">
          <div class="arrow"></div>
          <div class="text">Adicionar ao mapa interativo</div>
        </div>
      </button>

      <button v-if="selectedItem && selectedItem.metadata_id" @click="onClick_openMetadata" aria-label="Exibir Metadados">
        <i class="material-icons icon">list_alt</i>
        <div class="Tooltip-right">
          <div class="arrow"></div>
          <div class="text">Exibir Metadados</div>
        </div>
      </button>

      <button v-if="selectedItem && selectedItem.serie_id" @click="onClick_showEvolution" aria-label="Mostrar Evolução">
        <i class="material-icons icon">timeline</i>
        <div class="Tooltip-right">
          <div class="arrow"></div>
          <div class="text">Mostrar Evolução</div>
        </div>
      </button>

      <button v-if="selectedItem && isMap" @click="onClick_downloadLayer" aria-label="Fazer download desta camada">
        <i class="material-icons icon">image</i>
        <div class="Tooltip-right">
          <div class="arrow"></div>
          <div class="text">Download das camadas</div>
        </div>
      </button>

      <button v-if="selectedItem && pathToFile != '' && !isHTML" @click="onClick_downloadDocument" aria-label="Fazer download deste documento">
        <i class="material-icons icon">save_alt</i>
        <div class="Tooltip-right">
          <div class="arrow"></div>
          <div class="text">Download do documento</div>
        </div>
      </button>
    </div>

    <object v-if="pathToFileHideToolbar" :data="pathToFileHideToolbar" role="application" alt="Documento da publicação" style="height:100%;">
      <embed :src="pathToFileHideToolbar">
        <p>Seu browser não suporta PDFs.</p>
        <p><a target="_blank" :href="pathToFileHideToolbar">Clique Aqui para fazer o download do arquivo.</a></p>
      <!--</embed>-->
    </object>
    <div v-else class="front-page">
      <object :data="pathToCapa" alt="Capa da publicação" style="height: 100%;">
        <embed :src="pathToCapa">
          <p>Seu browser não suporta o carregamento desta página</p>
        <!--</embed>-->
      </object>
    </div>
  </div>
</template>

<script>
    import {
        httpGet,
        downloadDocument
    } from '@/util'
    import {
        mapActions
    } from 'vuex'
    import {
        APPLICATION_PATH,
        IBGE_GEOSERVER,
        URL_GETLAYERS,
        CAPA_PATH,
        PDFS_PATH,
        BRAZIL_EXTENT
    } from '@/const'

    const TIPONO_PDF = 1
    const TIPONO_MAP = 2

    export default {
        name: "Document",
        data() {
            return {
                CAPA_PATH,
                PDFS_PATH
            }
        },
        computed: {
            isHTML() {
                let ext = getUrlExtension(this.pathToFile)
                return ext == '.html' || ext == '.htm'
            },
            isDocument() {
                return this.selectedItem.tipo_no == TIPONO_PDF
            },
            isMap() {
                return this.selectedItem.tipo_no == TIPONO_MAP
            },
            selectedItem() {
                return this.$store.state.selectedItem
            },
            pathToCapa() {
                return CAPA_PATH
            },
            pathToFile() {
                if (this.selectedItem && this.selectedItem.pdf && this.selectedItem.pdf != '') {
                    let fileName = this.selectedItem.pdf
                    return PDFS_PATH + fileName
                }

                return ''
            },
            pathToFileHideToolbar() {
                if (this.selectedItem && this.selectedItem.pdf) {
                    // o parametro toolbar=0 esconde a barra lateral do visualizador de pdf nativos dos browsers em desktop
                    // e view=fitV ajusta o pdf exibido na altura
                    return this.pathToFile + '#toolbar=0'
                }

                return ''
            }
        },
        methods: {
            ...mapActions({
                addMultipleLayers: 'Map/addMultipleLayerProxy',
                removeAllLayers: 'Map/removeAllLayers',
            }),

            async onClick_addToMap(event) {
                console.log("onClick_addToMap")
                this.removeAllLayers()
                
                //let geoserver_url = await API.getGeoserverURL()
                //let sumario = await this.selectedItem.getSumario(geoserver_url)
                //let promise = this.selectedItem.criaCamadas(sumario)
                
                let promise = await this.selectedItem.getLayers()

                this.$store.state.UI.selectedMapInPublication = this.selectedItem
                this.addMultipleLayers([promise, 'nat'])
                History.add(this.selectedItem)

                this.$router.push({
                    name: 'map'
                })

                // Quando os campos minx, miny, maxx, maxy estão presentes e não nulos, realizar uma aproximação para área indicada no mapa
                // setTimeout adianta a execução desse trecho para esperar o carregamento do mapa
                // Não estando definido o bbox, sempre deve aproximar par ao Brasil inteiro.
                setTimeout(() => {
                    let l = promise[0] // ainda q o item do sumario tenha varias camadas, aproximamos para o zoom da primeira camada.
                    console.log(l)
                    let bounds;
                    if ([l.minx, l.miny, l.maxx, l.maxy].every(x => x != null)) {
                        console.log("Entrou no IFFF")
                        bounds = {
                            Minx: l.minx,
                            Miny: l.miny,
                            Maxx: l.maxx,
                            Maxy: l.maxy,
                        }
                    } else {
                      console.log("Entrou no EEEEELSE")
                        bounds = {
                            Minx: BRAZIL_EXTENT.Minx,
                            Miny: BRAZIL_EXTENT.Miny,
                            Maxx: BRAZIL_EXTENT.Maxx,
                            Maxy: BRAZIL_EXTENT.Maxy
                        }
                    }

                    this.$store.commit('Map/zoomToExtent', bounds)

                }, 500) 
                   
            },

            onClick_openMetadata(event) {
                let layer = this.selectedItem
                this.$router.push({
                    name: 'home.metadatadialog',
                    params: {
                        layer
                    }
                })
            },

            async onClick_showEvolution(event) {
                let serie_item = await this.selectedItem.getSerie()

                this.$router.push({
                    name: 'home.historicalseriedialog',
                    params: {
                        item: serie_item
                    }
                })
            },

            async onClick_downloadLayer(event) {
                let children = await this.selectedItem.getLayers()
                let layerData = children.map(elem => elem.id)
                let urlServer = children.map(elem => elem.url)
                let file = this.selectedItem.pdf.split('.')[0]
                let params = {
                    service: "WFS",
                    version: "1.0.0",
                    request: "GetFeature",
                    typeName: layerData.join(','),
                    outputFormat: "SHAPE-ZIP",
                    format_options: "filename:" + file.toLowerCase() + ".zip"
                }
                console.log('********************************************')
                console.log(layerData)     

                // A linha abaixo vai deixar de funcionar se as camadas vierem de geoservers diferentes.
                let url = (Array.isArray(urlServer) ? urlServer[0] : urlServer) + '?' + $.param(params)
                //let url = IBGE_GEOSERVER + '?' + $.param(params)

                for (let layerId of layerData) {
                    let opt = this.getLayerOptions(layerId)
                    if (opt && 'alt_download' in opt) {
                        url = opt['alt_download']
                        break
                    }
                }

                window.open(url, '_blank');

                this.$emit('onDownload', this.selectedItem)
            },

            onClick_downloadDocument(event) {
                let fileName = this.selectedItem.pdf
                downloadDocument(fileName)

                event.stopPropagation()
            },

            getLayerOptions(layerId) {
                if ('opcoes_camadas' in window.config) {
                    for (let opt of window.config.opcoes_camadas) {
                        if ('id' in opt && layerId.search(opt.id) != -1) {
                            return opt
                        }
                    }
                }
                return
            },
        }
    }
</script>
